﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { ICadDrawingAnnotationField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadDrawingAnnotationField, eOutputFieldType.cadDrawingAnnotation)
export class CadDrawingAnnotationField extends OutputField implements ICadDrawingAnnotationField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public value: string;
    public x: number;
    public y: number;
    public visible: boolean;
}
